import React from "react";
import ReactApexChart from "react-apexcharts";

const ApexChart = ({ options = {}, data, width, height }) => {
  const series = [
    {
      name: data[0][1],
      data: data
        .filter((obj, i) => i !== 0)
        .map((instance) => ({ x: instance[0], y: instance[1] })),
    },
  ];

  return (
    <div className="apex-chart">
      <div id="chart">
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          width={width}
          height={height}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default ApexChart;
